import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ObjectCardKind } from '@common/components/object-card';
import { monitoringAdapter, MonitoringState } from '@store/monitoring/monitoring.state';

export const selectMonitoringState = createFeatureSelector<MonitoringState>('monitoring');

const { selectAll, selectEntities, selectIds } =
  monitoringAdapter.getSelectors(selectMonitoringState);

export const selectAllMonitoring = selectAll;
export const selectMonitoringEntities = selectEntities;
export const selectMonitoringIds = selectIds;

export const selectLoadingMonitoringList = createSelector(
  selectMonitoringState,
  (state) => state.loading,
);

export const selectMonitoringById = (id: string | number) =>
  createSelector(selectMonitoringEntities, (entities) => entities[id]);

export const selectLastMessagesMonitoringObjects = createSelector(selectAllMonitoring, (state) =>
  state.map((m) => ({ lastMessage: m.lastMessage })),
);

// ------- showOnMap ---------
export const selectVisibleIds = createSelector(selectMonitoringState, (state) => state.visibleIds);

export const selectVisibleMap = createSelector(
  selectVisibleIds,
  (visibleIds) => new Set(visibleIds),
);

export const selectAreAllVisible = createSelector(
  selectMonitoringIds,
  selectVisibleIds,
  (allIds, visibleIds) => {
    const allIdsNum = allIds as number[];

    if (allIds.length === 0) return false;
    const visibleSet = new Set(visibleIds);
    return allIdsNum.every((id) => visibleSet.has(id));
  },
);
export const selectIsVisible = (id: number) =>
  createSelector(selectVisibleMap, (visibleMap) => visibleMap.has(id));

export const selectOpenedObjectCardOnMapId = createSelector(
  selectMonitoringState,
  (state) => state.openedObjectCardOnMapId,
);

export const selectTrackedObjectOnMapId = createSelector(
  selectMonitoringState,
  (state) => state.trackedObjectOnMapId,
);

// --------------- Object cards ---------------
export const selectObjectCards = createSelector(
  selectMonitoringState,
  (state) => state.objectCards,
);

export const selectObjectCard = (type: ObjectCardKind, objectId: number) =>
  createSelector(selectObjectCards, (cards) => cards[type][objectId] ?? null);

/** Фиксированные карточки, данные которых сейчас грузятся */
export const selectLoadingFixedObjectCardIdsSet = createSelector(
  selectMonitoringState,
  (state) => new Set(state.objectCardsLoading.fixed),
);

export const selectFixedObjectCardIds = createSelector(
  selectMonitoringState,
  (state) => state.fixedObjectCardIds,
);

export const selectFixedObjectCardIdsSet = createSelector(
  selectFixedObjectCardIds,
  (ids) => new Set(ids),
);

export const selectMaxRt = createSelector(selectMonitoringState, (state) => state.maxRt ?? 0);
// ---------------------------------------------

// ------- showOnMap ---------

// export const selectFilteredAndSortedMonitoring = createSelector(
//   selectAllMonitoring,
//   selectMonitoringState,
//   (monitoring, state) => {
//     let result = [...monitoring];
//
//     if (state.searchText) {
//       result = result.filter((item) =>
//         item.name.toLowerCase().includes(state.searchText!.toLowerCase()),
//       );
//     }
//
//     if (state.sortBy) {
//       result = result.sort((a, b) => {
//         const valA: any = a[state.sortBy!];
//         const valB: any = b[state.sortBy!];
//         return state.sortDirection === 'asc' ? (valA > valB ? 1 : -1) : valA < valB ? 1 : -1;
//       });
//     }
//
//     return result;
//   },
// );
